

// Standard project-wide date format: MM/DD/YYYY
export const formatDate = (value) => {
  if (value == null || value === "") {
    return "";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

export const timeAgo = (dateString) => {
    if (dateString == null || dateString === "") {
      return "";
    }
    const now = new Date();
    const createdAt = new Date(dateString);
    if (Number.isNaN(createdAt.getTime())) {
      return "";
    }
    const diff = (now - createdAt) / 1000; // difference in seconds

    if (diff < 60) return `${Math.floor(diff)} seconds ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)} minutes ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
    if (diff < 604800) return `${Math.floor(diff / 86400)} days ago`;
    if (diff < 2419200) return `${Math.floor(diff / 604800)} weeks ago`;

  return formatDate(createdAt); // fallback
};

export const getCorsSafeMediaUrl = (url) => {
  if (!url || typeof url !== "string") {
    return url;
  }

  const trimmedUrl = url.trim();

  if (
    !trimmedUrl ||
    trimmedUrl.startsWith("/") ||
    trimmedUrl.startsWith("blob:") ||
    trimmedUrl.startsWith("data:")
  ) {
    return trimmedUrl;
  }

  try {
    const parsedUrl = new URL(trimmedUrl, window.location.origin);
    const isSameOrigin = parsedUrl.origin === window.location.origin;
    const isLocalDevHost =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";

    if (isSameOrigin || !isLocalDevHost) {
      return parsedUrl.toString();
    }

    const fileName = parsedUrl.pathname.split("/").pop() || "file";
    const safeFileName = encodeURIComponent(fileName);

    if (fileName.toLowerCase().endsWith(".usdz")) {
      return `/__usdz_proxy/${safeFileName}?url=${encodeURIComponent(
        parsedUrl.toString()
      )}`;
    }

    return `/__media_proxy?url=${encodeURIComponent(parsedUrl.toString())}`;
  } catch {
    return trimmedUrl;
  }
};

export const MonthYearDisplay = ({ dateString }) => {
    //console.log("dateString", dateString);
    const date = new Date(dateString);
    const formatted = new Intl.DateTimeFormat("en-IN", {
      month: "long",
      year: "numeric",
    }).format(date);
    return formatted;
  };
